import { ClassNames } from "@emotion/react";
import MuiIconButton from "@mui/material/IconButton";
import { forwardRef, MouseEventHandler, ReactNode, JSX } from "react";

import { StylableProps } from "@rewards-web/shared/types";

interface IconButtonProps extends StylableProps {
  children: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  "aria-label": string;
  disabled?: boolean;
  color?: "default" | "inherit" | "primary" | "secondary";
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    { className, children, onClick, "aria-label": ariaLabel, disabled, color },
    ref
  ): JSX.Element => {
    return (
      <ClassNames>
        {({ css, cx, theme }) => (
          <MuiIconButton
            ref={ref}
            // "large" for its 12px padding
            size="large"
            className={cx(
              css`
                /* sizes 1em (FontAwesome) icons; "large" alone would make them 28px */
                font-size: ${theme.typography.pxToRem(24)};
              `,
              className
            )}
            aria-label={ariaLabel}
            onClick={onClick}
            disabled={disabled}
            color={color}
          >
            {children}
          </MuiIconButton>
        )}
      </ClassNames>
    );
  }
);
